import { BayerOrdered, Image, type Printer } from "escpos-buffer";
import { toPng } from "html-to-image";
import { useEffect, useRef, useState } from "react";
import useThermalPrinter from "./use-thermal-printer";

const useThermalPrintDivAsImage = () => {
  const printableRef = useRef<HTMLDivElement>(null);
  const { print: thermalPrint, error: printerError } = useThermalPrinter();
  const [error, setError] = useState<Error>(null);

  useEffect(() => {
    if (!printerError) {
      return;
    }
    setError(printerError);
  }, [printerError]);

  const printImage = async (printer: Printer) => {
    try {
      const dataUrl = await toPng(printableRef.current, {
        cacheBust: true,
        pixelRatio: 2,
      });
      const b64Png = dataUrl.split(",")[1];
      const buffer = Buffer.from(b64Png, "base64");

      const image = new Image(buffer, new BayerOrdered());
      await printer.draw(image);

      await printer.feed(4);
      await printer.cutter();
    } catch (err) {
      setError(err);
    }
  };

  return {
    print: () => thermalPrint(printImage),
    printableRef,
    error,
  };
};

export default useThermalPrintDivAsImage;
